import { type ChatOptions } from '@chatbot/typings/types';
import type { App, Plugin } from 'vue';

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $chatOptions: ChatOptions;
    }
}

export const ChatPlugin: Plugin = {
    install(app: App, options: ChatOptions) {
        // Make chat options available globally
        app.config.globalProperties.$chatOptions = options;

        // Provide the options so any component can inject them
        app.provide('chatOptions', options);
    },
};
